import CheckIcon from '@mui/icons-material/Check';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { Box, Button, Menu } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { useI18n } from '../../../../../../application/language/useI18n';
import { ProjectInfoDomain } from '../store/ProjectInfoDomain';
import { InvitationLinkList } from './InvitationLinkList';
import { InvitationRolesList } from './InvitationRolesList';
import { Colors } from '../../../../../design/color/Colors';

export interface IInvitationLinkProperties {
  domain: ProjectInfoDomain;
  projectId: string;
  title?: string;
}

export const InvitationLink = observer(({ domain, projectId, title }: IInvitationLinkProperties) => {
  const { translate } = useI18n();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showCheckboxList, setShowCheckboxList] = useState(false);
  const links = domain.ui.invitationLinks.list || [];

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setShowCheckboxList(false);
  };

  return (
    <>
      <Button
        sx={{ color: Colors.primaryLight, fontSize: 16 }}
        startIcon={
          <Box sx={{ transform: 'rotate(120deg)', position: 'relative', top: -3 }}>
            <InsertLinkIcon />
          </Box>
        }
        variant="text"
        onClick={handleClick}
      >
        {translate('projectPage.invitationLink')}
      </Button>

      {anchorEl && (
        <Menu sx={{ maxHeight: '500px', width: '420px' }} anchorEl={anchorEl} open={open} onClose={handleClose}>
          {links.length && !showCheckboxList ? (
            <InvitationLinkList
              handleNewInvitationLink={() => setShowCheckboxList(true)}
              domain={domain}
              projectId={projectId}
              handleClose={handleClose}
            />
          ) : (
            <InvitationRolesList domain={domain} projectId={projectId} handleClose={handleClose} />
          )}
        </Menu>
      )}
    </>
  );
});
